<script setup lang="ts">
import { HomeButton } from '@/components/home'
import LuckyRushButtonBgImage from '@/assets/images/periodic/lucky-rush/lucky-rush-button-bg.png'
import TicketImage from '@/assets/images/gifs/ticket.gif'
import { useGiveaway } from '@/composables/game/giveaway'

withDefaults(defineProps<{
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdown, shouldShowLuckyRushButton } = useGiveaway()
</script>

<template>
  <HomeButton
    label="Lucky Rush"
    :countdown="countdown ? { value: countdown, dangerThreshold: 3600 * 6 } : undefined"
    button-class="overflow-hidden"
  >
    <img
      class="size-full object-cover z-[3]"
      :src="LuckyRushButtonBgImage"
    >
    <img
      class="absolute size-10 object-cover left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[4]"
      :src="TicketImage"
    >
  </HomeButton>
</template>
